import React, { useState } from "react";
import { Tabs } from "antd";
import styled from "@emotion/styled";
import { useSearchParams } from "react-router-dom";
import UploadTab from "./UploadTab";
import CoverageTab from "./CoverageTab";
import JobsTab from "./JobsTab";
import ScoresTab from "./ScoresTab";
import SlotsTab from "./SlotsTab";

const PageContent = styled.div`
  background: #fff;
  width: 100%;
  min-height: calc(100vh - 130px);
`;

/**
 * Episode Scoring: upload an Amagi airing report, see what is loaded, follow the jobs, and read the
 * scores and the slot strengths behind them. One sub-tab per table; the active tab lives in the URL (?tab=) so it can be bookmarked.
 */
const EpisodeScoring: React.FC = () => {
  const [params, setParams] = useSearchParams();
  const active = params.get("tab") || "upload";
  // Bumped after a submit so the Jobs and Loaded Data tabs refetch.
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <PageContent>
      <Tabs
        activeKey={active}
        onChange={(key) => setParams({ tab: key })}
        tabBarStyle={{ paddingLeft: 24, marginBottom: 0, background: "#fff", position: "sticky", top: 64, zIndex: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
        items={[
          { key: "upload", label: "Upload", children: <UploadTab onSubmitted={() => { setRefreshKey((k) => k + 1); setParams({ tab: "jobs" }); }} /> },
          { key: "loaded", label: "Loaded Data", children: <CoverageTab refreshKey={refreshKey} /> },
          { key: "jobs", label: "Jobs", children: <JobsTab refreshKey={refreshKey} /> },
          { key: "scores", label: "Scores", children: <ScoresTab refreshKey={refreshKey} /> },
          { key: "slots", label: "Slot Strength", children: <SlotsTab refreshKey={refreshKey} /> },
        ]}
      />
    </PageContent>
  );
};

export default EpisodeScoring;
